<script lang="ts">
export default {
  name: 'UILabel',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { Label } from 'reka-ui';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
  for?: string;
}

const props = defineProps<Props>();

const labelClass = computed(() =>
  cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', props.class),
);

const htmlFor = computed(() => props.for);
</script>

<template>
  <Label :for="htmlFor" :class="labelClass" v-bind="$attrs">
    <slot />
  </Label>
</template>
